import { render, staticRenderFns } from "./layoutSegfy.vue?vue&type=template&id=41e4ed93&"
import script from "./layoutSegfy.vue?vue&type=script&lang=js&"
export * from "./layoutSegfy.vue?vue&type=script&lang=js&"
import style0 from "./layoutSegfy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "layoutSegfy.vue"
export default component.exports